import React, { useEffect } from "react";
import { Chart } from "chart.js";
import toPersianNumber from "../../../helpers/actions/toPersianNumber";

let myLineChart;
Chart.defaults.global.defaultFontFamily = "IRANSans";
const chartRef = React.createRef();

const LineChart = (props) => {

    const toPersianLabels = type => {
        let temp = []
        if (type == 'labels') {
            props.labels.forEach(item => {
                temp.push(toPersianNumber(item))
            });
        }
        if (type == 'data') {
            props.data.forEach(item => {
                let key = {
                    persianData: toPersianNumber(item),
                    data: item
                }
                temp.push(key)
            })
        }
        return temp
    }
    useEffect(() => {
        const myChartRef = props.refrence.current.getContext("2d");

        if (typeof myLineChart !== "undefined") myLineChart.destroy();
        window[myLineChart + props.tag] = new Chart(myChartRef, {
            type: "line",
            data: {
                //Bring in data
                labels: toPersianLabels('labels'),
                datasets: [
                    {
                        label: "تعداد فروش",
                        // data: toPersianLabels('data'),
                        data: props.data,
                        fill: false,
                        borderColor: "#192a56",
                        backgroundColor: "#192a56",
                    }
                ]
            },
            gridLines: {
                display: false
            },
            options: {
                responsive: true,
                layout: {
                    padding: {
                        top: 5
                    }
                },
                legend: {
                    display: false,

                },
                scales: {
                    xAxes: [{
                        gridLines: {
                            display: false
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            callback: function (value, index, values) {
                                return (value % 1 == 0 ? toPersianNumber(value) : '')
                            }
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, chart) {
                            let string = `تعداد فروش: ${toPersianNumber(tooltipItem.value)}`
                            return string
                        }
                    }
                }
            },
        });
    }, [props]);
    return <canvas ref={props.refrence} style={{ boxSizing: "border-box", width: "90%" }} height="297"></canvas>
}
export default LineChart